class PluginRegistryImpl {
    constructor() {
        this._manifests = new Map();
    }
    register(manifest) {
        this._manifests.set(manifest.gameId, manifest);
    }
    getById(gameId) {
        return this._manifests.get(gameId);
    }
    getAll() {
        return [...this._manifests.values()];
    }
    _reset() {
        this._manifests.clear();
    }
}
export const PluginRegistry = new PluginRegistryImpl();
